module.exports = __webpack_public_path__ + "static/07-32829ede0e9475cb5a1e003888edd636.jpg";